import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { Observable } from 'rxjs';


export function correlationInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const tokenKey = 'X-Correlation-ID'

    // Get the ID from session storage
    let token = sessionStorage.getItem(tokenKey);

    // If token doesn't exists create it
    if(!token){
        token = uuidv4();
        sessionStorage.setItem(tokenKey, token)
    }

    // Clone the request and replace the original headers with
    // cloned headers, updated with the correlation ID.
    const correlationReq = req.clone({
      headers: req.headers.set('X-Correlation-ID', token)
    });

  return next(correlationReq);
}